
import React, { useEffect, useState, useCallback } from 'react'
import { wwwRoot, cookieUtil } from '@liepin/js-core4c-fe';
import { isC, isWWW, needCheckCity } from '../modules/const';

export enum EInputFromType{
  WWWHome = 'www_index',
  CHome = 'c_index',
  SearchList = 'search_list',
  CampusIndex = 'campus_index',
  JobDetail = 'job_detail'
}

const useSearchJob: React.FC = () => {
  const city = cookieUtil.get('city_site') || '';

  const [jobURL, setJobURL] = useState<string>(
    needCheckCity ? `${wwwRoot}/city-${city}/zhaopin/?init=1` : `${wwwRoot}/zhaopin/?init=1`
  );

  let inputFrom: EInputFromType = EInputFromType.SearchList;

  const { pathname } = window.location;
  if (isWWW) {
    if (pathname === '/') {
      inputFrom = EInputFromType.WWWHome;
    } else if (pathname.includes('/compus')) {
      inputFrom = EInputFromType.CampusIndex;
    } else if (pathname.includes('/job') || pathname.includes('/atsjob')) {
      inputFrom = EInputFromType.JobDetail;
    }
  } else if (isC) {
    if (pathname === '/') {
      inputFrom = EInputFromType.CHome;
    }
  }

  const getParams = useCallback(() => {
    let workYearCode = '0';

    // 如果已登录且是学生身份 或 校园首页
    if ((window.CUserInfo && window.CUserInfo?.studentUser)
      || inputFrom === EInputFromType.CampusIndex) {
      workYearCode = '1';
    }
    const params = `inputFrom=${inputFrom}&workYearCode=${workYearCode}`;
    return params;
  }, []);

  // 搜索条都到主站主搜页
  const getSearchURL = useCallback(() => `${wwwRoot}/zhaopin/?${getParams()}`, [getParams]);

  // 在useEffect重新赋值，保证seo-header不会报错
  const getJobURL = useCallback(() => {
    // 只有在城市分站中需要使用城市
    const url = needCheckCity ? `${wwwRoot}/city-${city}/zhaopin/` : `${wwwRoot}/zhaopin/`;
    const params = getParams();
    return `${url}?${params}`;
  }, []);

  return {
    jobURL,
    getSearchURL,
    getJobURL
  }
}

export default useSearchJob
